import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, Tabs, TabsProps, message } from "antd";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GeneralAlerts from "../../components/settings/TabsClients/GeneralAlerts";
import LoyaltyProgram from "../../components/settings/TabsClients/LoyaltyProgram";
import ReservationsAlerts from "../../components/settings/TabsClients/ReservationsAlerts";
import {
  addNewSettingsClient,
  getSettingsClient,
} from "../../network/settings";
import queryClient from "../../services/react-query/queryClient";

const ClientsSettings = (props: any) => {
  const [type, setType] = useState("general_alerts");
  const { locationId } = useSelector(
    (state: {
      calendar: {
        locationId: number | null;
      };
    }) => {
      return {
        locationId: state.calendar.locationId,
      };
    }
  );
  const { data, isLoading } = useQuery(
    ["settingsClient", locationId, type],
    () => getSettingsClient(locationId, { settingGroup: type }),
    { enabled: !!locationId }
  );
  const { mutate: AddNewSettingsClient, isLoading: load } = useMutation(
    addNewSettingsClient,
    {
      onSuccess: (res: any) => {
        if (
          res?.response?.status === 422 ||
          res?.response?.status === 500 ||
          res?.code === "ERR_BAD_REQUEST"
        ) {
          message.error(res?.response?.data?.message);
        } else {
          message.success(" Settings updated successfully");
          queryClient.invalidateQueries(["settingsClient"]);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );
  const [form] = Form.useForm();

  const items: TabsProps["items"] = [
    {
      key: "loyalty_programs",
      label: (
        <div className="text-[#4f5062] w-full px-2 py-1">
          <FormattedMessage id="loyalty_programs" />
        </div>
      ),
      children: <LoyaltyProgram data={data} />,
    },
    {
      key: "general_alerts",
      label: (
        <div className="text-[#4f5062] w-full px-2 py-1">
          <FormattedMessage id="generalAlerts" />
        </div>
      ),
      children: <GeneralAlerts data={data} />,
    },
    {
      key: "reservations_alerts",
      label: (
        <div className="text-[#4f5062] w-full px-2 py-1">
          <FormattedMessage id="reservationAlerts" />
        </div>
      ),
      children: <ReservationsAlerts data={data} />,
    },

    // {
    //   key: "overbooking_alerts",
    //   label: (
    //     <div className="text-[#4f5062] w-full px-2 py-1">
    //       <FormattedMessage id="overbookingAlerts" />
    //     </div>
    //   ),
    //   children: <OverbookingAlerts data={data} />,
    // },
  ];
  const onChange = (key: string) => {
    console.log(key);
    setType(key);
  };
  const navigate = useNavigate();
  const intl = useIntl();

  useEffect(() => {
    if (!isLoading && data) {
      const settings = data?.data?.map((item: any) => item?.value);
      switch (type || "general_alerts") {
        case "general_alerts":
          form.setFieldsValue({
            alerts_before_booking_time: settings[0]?.alerts_before_booking_time,
            enable_alerts_before_booking:
              settings[0]?.enable_alerts_before_booking,
            alerts_before_booking_same_day_time:
              settings[1]?.alerts_before_booking_same_day_time,
            enable_alerts_before_booking_same_day:
              settings[1]?.enable_alerts_before_booking_same_day,
            // enable_notices_via_email: settings[2]?.enable_notices_via_email,
            // enable_notices_via_phone: settings[3]?.enable_notices_via_phone,
          });
          break;
        case "reservations_alerts":
          form.setFieldsValue({
            enable_alerts_before_booking:
              settings[0]
                ?.enable_customers_notification_reservation_details_after_booking,
            enable_alert_customer_if_not_appear:
              settings[1]?.enable_alert_customer_if_not_appear,
            enable_alert_reservation_if_cancelled:
              settings[2]?.enable_alert_reservation_if_cancelled,
            enable_alert_reservation_rescheduled:
              settings[3]?.enable_alert_reservation_rescheduled,
            enable_notices_reservation_via_email:
              settings[4]?.enable_notices_reservation_via_email,
            enable_notices_reservation_via__phone:
              settings[5]?.enable_notices_reservation_via_phone,
          });
          break;
        case "overbooking_alerts":
          form.setFieldsValue({
            alert_rebooking_after_reservation_to_customer_day:
              settings[0]?.alert_rebooking_after_reservation_to_customer_day,
            enable_alert_rebooking_after_reservation_to_customer:
              settings[0]?.enable_alert_rebooking_after_reservation_to_customer,
            enable_alerts_advance_via_email:
              settings[1]?.enable_alerts_advance_via_email,
            enable_alerts_ahead_time_via_phone:
              settings[2]?.enable_alerts_ahead_time_via_phone,
          });
          break;
        default:
          // Optional: Handle unknown type
          console.warn(`Unhandled type: ${type}`);
      }
    }
  }, [type, data, isLoading, form]); // Dependencies

  const onFinish = (values: any) => {
    let filteredValues;
    const settings = data?.data?.map((item: any) => item);
    console.log(settings[0]);

    switch (type || "general_alerts") {
      case "general_alerts":
        filteredValues = [
          {
            id: settings[0]?.id,
            value: {
              alerts_before_booking_time: values.alerts_before_booking_time,
              enable_alerts_before_booking: values.enable_alerts_before_booking,
            },
          },
          {
            id: settings[1]?.id,
            value: {
              alerts_before_booking_same_day_time:
                values.alerts_before_booking_same_day_time,
              enable_alerts_before_booking_same_day:
                values.enable_alerts_before_booking_same_day,
            },
          },
          // {
          //   id: settings[2]?.id,
          //   value: {
          //     enable_notices_via_email: values.enable_notices_via_email,
          //   },
          // },
          // {
          //   id: settings[3]?.id,
          //   value: {
          //     enable_notices_via_phone: values.enable_notices_via_phone,
          //   },
          // },
        ];
        break;
      case "reservations_alerts":
        filteredValues = [
          {
            id: settings[0]?.id,
            value: {
              enable_customers_notification_reservation_details_after_booking:
                values.enable_alerts_before_booking,
            },
          },
          {
            id: settings[1]?.id,
            value: {
              enable_alert_customer_if_not_appear:
                values.enable_alert_customer_if_not_appear,
            },
          },
          {
            id: settings[2]?.id,
            value: {
              enable_alert_reservation_if_cancelled:
                values.enable_alert_reservation_if_cancelled,
            },
          },
          {
            id: settings[3]?.id,
            value: {
              enable_alert_reservation_rescheduled:
                values.enable_alert_reservation_rescheduled,
            },
          },
          {
            id: settings[4]?.id,
            value: {
              enable_notices_reservation_via_email:
                values.enable_notices_reservation_via_email,
            },
          },
          {
            id: settings[5]?.id,
            value: {
              enable_notices_reservation_via_phone:
                values.enable_notices_reservation_via__phone,
            },
          },
        ];
        break;
      case "overbooking_alerts":
        filteredValues = [
          {
            id: settings[0]?.id,
            value: {
              alert_rebooking_after_reservation_to_customer_day:
                values.alert_rebooking_after_reservation_to_customer_day,
              enable_alert_rebooking_after_reservation_to_customer:
                values.enable_alert_rebooking_after_reservation_to_customer,
            },
          },
          {
            id: settings[1]?.id,
            value: {
              enable_alerts_advance_via_email:
                values.enable_alerts_advance_via_email,
            },
          },
          {
            id: settings[2]?.id,
            value: {
              enable_alerts_ahead_time_via_phone:
                values.enable_alerts_ahead_time_via_phone,
            },
          },
        ];
        break;
      default:
        console.warn(`Unhandled type on finish: ${type}`);
        filteredValues = [...values]; // Default to returning all values if type is unknown
        break;
    }
    AddNewSettingsClient({ data: filteredValues });
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <div className="w-full">
        <div className="flex items-center gap-2 text-2xl font-semibold leading-7 text-color-primary text-end">
          <FormattedMessage id="settingsTitle" />
        </div>
        <div className="my-4 text-base font-normal leading-7 text-color-gray">
          <FormattedMessage id="settingsDescription" />
        </div>
        <div className="settings">
          <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChange}
            tabBarStyle={{ margin: 0 }}
          />
        </div>
        <div className="flex items-end justify-end w-full gap-4 my-4 mt-8 text-left">
          {type !== "loyalty_programs" && (
            <Button
              type="primary"
              htmlType="submit"
              className="w-fit min-w-[150px] max-w-[150px]"
              loading={load}
            >
              {intl.formatMessage({ id: "saveChanges" })}
            </Button>
          )}
          <Button
            type="primary"
            className="btn-primary-not w-fit max-w-[150px] min-w-[150px]"
            onClick={() => navigate(-1)}
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default ClientsSettings;
